import React from 'react';
import './index.scss';

const BubbleTip = (porps: any) => {
  const { tableData } = porps;
  return (
    <div className="dbi-charttip-bubble">
      <div className="dbi-charttip-bubble-title">
        <div className="bubble-title-flex">
          <span className="bubble-title-flex-text">{tableData?.title}</span>
        </div>
        <div className="bubble-title-text">{tableData?.titleNow}</div>
      </div>
      {tableData?.list?.map((item: any, index: any) => {
        return (
          <div className="dbi-charttip-bubble-line" key={index}>
            <div className="dbi-charttip-bubble-lf">
              {item?.color ? (
                <span
                  className="bubble-lf-round"
                  style={{ backgroundColor: item?.color }}
                />
              ) : (
                ''
              )}
              {item?.img ? (
                <span className="bubble-lf-imgbox">
                  <img src={item.img} className="bubble-lf-img" />
                </span>
              ) : (
                ''
              )}
              <span className="bubble-lf-name">{item?.title}</span>
            </div>
            <div className="dbi-charttip-bubble-rt">
              {item?.num ? item?.num : '-'}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BubbleTip;
